import Loader from "@/components/Loader/Loader";
import PermissionChecker from "@/components/PrivacyComponent/PermissionChecker";
import { Suspense, lazy } from "react";
import { Route } from "react-router-dom";

export default function useSettingRoutes() {
  const AppSettings = lazy(() =>
    import("@/components/Settings/AppSettings/AppSettings")
  );
  const InvoiceSetting = lazy(() =>
    import("@/components/Settings/InvoiceSetting")
  );
  const GetAllMajor = lazy(() =>
    import("@/components/CRM/Setup/UniversitySetup/Major/GetAllMajor")
  );
  const GetAllDegree = lazy(() =>
    import("@/components/CRM/Degree/GetAllDegree")
  );
  const LeadFieldSetup = lazy(() =>
    import("@/components/Lead/Leads/LeadFieldSetup")
  );
  const DealFieldSetup = lazy(() =>
    import("@/components/CRM/Deal/DealFieldSetup")
  );
  const GetAllInterest = lazy(() =>
    import("@/components/Lead/Interest/GetAllInterest")
  );
  const GetAllSemesterRegistered = lazy(() =>
    import("@/components/Lead/SemesterRegistered/GetAllSemesterRegistered")
  );
  const routes = [

    <Route
      path='company-settings'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <PermissionChecker permission={"readAll-setting"}>
            <InvoiceSetting />
          </PermissionChecker>
        </Suspense>
      }
      key='company-setting'
    />,
    <Route
      path='setup/app-settings'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <PermissionChecker permission={["readAll-emailConfig", "readAll-duplicateConfig"]}>
            <AppSettings />
          </PermissionChecker>
        </Suspense>
      }
      key='app-settings'
    />,
    <Route
      path='setup/major'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <GetAllMajor />
        </Suspense>
      }
      key='major-setup'
    />,
    <Route
      path='setup/degree'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <PermissionChecker permission={"readAll-degree"}>
            <GetAllDegree />
          </PermissionChecker>
        </Suspense>
      }
      key='degree-setup'
    />,
    <Route
      path='setup/lead-fields'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <PermissionChecker permission={"update-setting"}>
            <LeadFieldSetup />
          </PermissionChecker>
        </Suspense>
      }
      key='lead-field-setup'
    />,
    <Route
      path='setup/deal-fields'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <PermissionChecker permission={"update-setting"}>
            <DealFieldSetup />
          </PermissionChecker>
        </Suspense>
      }
      key='deal-field-setup'
    />,
    <Route
      path='setup/interest'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <PermissionChecker permission={"readAll-interest"}>
            <GetAllInterest />
          </PermissionChecker>
        </Suspense>
      }
      key='interest-setup'
    />,
    <Route
      path='setup/semester-registered'
      exact
      element={
        <Suspense fallback={<Loader />}>
          <PermissionChecker permission={"readAll-semesterRegistered"}>
            <GetAllSemesterRegistered />
          </PermissionChecker>
        </Suspense>
      }
      key='semester-registered-setup'
    />,
  ];
  return routes;
}
